import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35fdc1f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrdersWithoutAddressListItem" }
const _hoisted_2 = { class: "OrdersWithoutAddressListItem__container" }
const _hoisted_3 = { class: "flex flex-col items-start" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "flex flex-col items-end" }
const _hoisted_6 = { class: "OrdersWithoutAddressListItem__actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-pin mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, "ID: " + _toDisplayString(_ctx.item.id), 1),
        _createElementVNode("p", null, "Компания: " + _toDisplayString(_ctx.item.company_name), 1),
        _createElementVNode("p", null, "Адрес: " + _toDisplayString(_ctx.item.full_address ? _ctx.item.full_address : 'Не указан'), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.item.sender_full_name), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.item.sender_phone), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_the_button, {
        class: "primary small text",
        disabled: _ctx.setDisabled,
        onClick: _ctx.emitSetAddress
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" Указать адрес ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}